export default "__VITE_ASSET__BOqS_Pz0__"